import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IStore } from "../../DataTypes/storeTypes";
import { selectLocation } from "../../Actions/locationActions";

export const Location = () => {
    const dispatch = useDispatch();
    const { locations, selectedLocationId } = useSelector((state: IStore) => {
        const info = state.stepsInfo[state.common.currentStep];

        return {
            locations: [...state.locations],
            selectedLocationId: info.id,
        };
    });

    useEffect(() => {
        //select single location
        if (locations.length === 1 && !selectedLocationId) {
            dispatch(selectLocation(locations[0].id));
        }
    }, [locations]);

    const availableLocations = locations.map((l) => {
        const isSelected = l.id === selectedLocationId;

        return (
            <a
                key={l.id}
                className={`big-btn location-big-btn ${isSelected ? "selected" : ""}`}
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    dispatch(selectLocation(l.id));
                }}
            >
                {isSelected ? <i className="fa fa-check" /> : null}
                {l.name}
            </a>
        );
    });

    return (
        <div className="row">
            <div className="col-11 ml-auto mr-auto">
                {availableLocations.length ? (
                    availableLocations
                ) : (
                    <p style={{ textAlign: "center" }}>No locations are available.</p>
                )}
            </div>
        </div>
    );
};
